"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _form = _interopRequireDefault(require("./form"));

var _field = _interopRequireDefault(require("../fields/field"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ComponentDefinitionField = /*#__PURE__*/function (_Field) {
  (0, _inherits2.default)(ComponentDefinitionField, _Field);

  var _super = _createSuper(ComponentDefinitionField);

  function ComponentDefinitionField() {
    (0, _classCallCheck2.default)(this, ComponentDefinitionField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ComponentDefinitionField, [{
    key: "_setValue",
    value: // Leave _className with the inherited value of "Field" so that the UI knows how to render (hide)
    // it. FUTURE: we may want to define something like a HiddenField that the we can use to represent
    // a Field that should not be rendered.
    //
    // _className = 'ComponentDefinitionField';
    function _setValue(value) {
      if (value !== null) {
        // Also allow for "componentName" as "component" is a MSON keyword and results in compilation
        value = _objectSpread(_objectSpread({}, value), {}, {
          component: value.component ? value.component : value.componentName,
          componentName: undefined
        });
      }

      (0, _get2.default)((0, _getPrototypeOf2.default)(ComponentDefinitionField.prototype), "_setValue", this).call(this, value);
    }
  }]);
  return ComponentDefinitionField;
}(_field.default); // Note: we use JS to define the component so that we can use `instanceof ComponentForm`


var ComponentForm = /*#__PURE__*/function (_Form) {
  (0, _inherits2.default)(ComponentForm, _Form);

  var _super2 = _createSuper(ComponentForm);

  function ComponentForm() {
    var _this;

    (0, _classCallCheck2.default)(this, ComponentForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'ComponentForm');
    return _this;
  }

  (0, _createClass2.default)(ComponentForm, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(ComponentForm.prototype), "_create", this).call(this, props);
      var fields = [// A JSON blob defining the component. We define a ComponentDefinitionField so that we can
      // dynamically modify the value, to workaround the fact that the "component" keyword cannot be
      // used in MSON.
      new ComponentDefinitionField({
        name: 'definition',
        label: 'Definition',
        required: true
      })]; // By default, lock down access

      var access = {
        form: {
          create: 'admin',
          read: 'admin',
          update: 'admin',
          archive: 'admin'
        }
      };
      this.set({
        access: access,
        fields: fields
      });
    }
  }]);
  return ComponentForm;
}(_form.default);

exports.default = ComponentForm;